import React, { useState } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useAuthContext } from '../../Hooks/useAuthContext'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import axios from 'axios'
import Navigation from '../../Component/Navigation/Navigation'

function ResetPassword() {
  const [data, setData]               = useState([])
  const [disabled, setDisabled]       = useState(false)
  const { user, dispatch }            = useAuthContext()
  const [btnState, setBtnState]       = useState('Reset Password')
  const [seePassword, setSeePassword] = useState(false)
  const navigate                      = useNavigate()

  const params = new URLSearchParams(window.location.search)
  const token  = params.get('token')

  const handleSubmit = (e) => {
    e.preventDefault()
    setDisabled(true)
    setBtnState('Processing...')
    console.log('in handle submit')
    console.log(process.env.REACT_APP_API_URL)
    axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/user/reset-password`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    ).then(response => {
      setDisabled(false)
      navigate('/login')
      setBtnState('Reset Password')
      toast.success('Password Changed Successfully')
    }).catch(error => {
      setDisabled(false)
      console.log('in bad response')
      setBtnState('Reset Password')
      if (error.response.data.error === undefined) {
        toast.error('An Error Occured')
      } else {
        toast.error(error.response.data.error)
      }
    })
  }

  return (
    <div className="auth-page">
      <Navigation />

      <div className="auth-split">

        {/* ── Left — image panel ─────────────────────────── */}
        <div className="auth-split__image">
          <div className="auth-split__image-body">
            <span className="auth-split__label">JFE Bank — Account Security</span>
            <h2 className="auth-split__title">
              Create a new <em>password</em>
            </h2>
            <p className="auth-split__sub">
              Choose a strong password to keep your account secure.
              You will be redirected to login once your password is updated.
            </p>
            <ul className="auth-trust">
              <li>Minimum 8 characters</li>
              <li>Include uppercase &amp; lowercase letters</li>
              <li>Include numbers &amp; special characters</li>
            </ul>
          </div>
        </div>

        {/* ── Right — form panel ─────────────────────────── */}
        <div className="auth-split__form">
          <div className="auth-card">
            <div className="auth-card__bar" />

            <div className="auth-card__head">
              <h2>Change Password</h2>
              <p>Enter your new password below to complete the reset.</p>
            </div>

            <form className="auth-card__body" onSubmit={handleSubmit}>

              <div className="auth-info">
                Your reset link is valid for a limited time. Set your new
                password now to regain access to your account.
              </div>

              <div className="auth-field">
                <label>New Password</label>
                <div className="auth-field__pw">
                  <input
                    type={seePassword ? 'text' : 'password'}
                    placeholder="Enter Password"
                    value={data?.password}
                    onChange={(e) => setData({ ...data, password: e.target.value })}
                    required
                  />
                  <button
                    type="button"
                    className="auth-field__pw-toggle"
                    onClick={() => { console.log(seePassword ? 'Eye Slash' : 'Eye'); setSeePassword(!seePassword) }}
                  >
                    {seePassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="auth-btn auth-btn--navy"
                disabled={disabled}
              >
                {btnState}
              </button>

              <div className="auth-divider" />

              <Link to="/login" style={{ textDecoration: 'none' }}>
                <button type="button" className="auth-btn auth-btn--outline">
                  ← Back to Login
                </button>
              </Link>

            </form>
          </div>
        </div>

      </div>
    </div>
  )
}

export default ResetPassword